import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
export default function SectionSeparator() {
    return _jsx(View, { className: "bg-gray-10 h-[13px]" });
}
